interface ActionTypes {
  GET_WEB_LAUNCHER_START: string;
  GET_WEB_LAUNCHER_SUCCESS: string;
  GET_WEB_LAUNCHER_FAILURE: string;
  CLEAR_WEB_LAUNCHER: string;
}

export const WebLauncherLandingActionTypes: ActionTypes = {
  GET_WEB_LAUNCHER_START: '@@GET_WEB_LAUNCHER_START',
  GET_WEB_LAUNCHER_SUCCESS: '@@GET_WEB_LAUNCHER_SUCCESS',
  GET_WEB_LAUNCHER_FAILURE: '@@GET_WEB_LAUNCHER_FAILURE',
  CLEAR_WEB_LAUNCHER: '@@CLEAR_WEB_LAUNCHER'
};

export interface WebLaunchRequest {
  id: number;
  uuid: string;
  requestType: string;
  payload?: any;
  response?: any;
}

export interface WebLauncherLandingState {
  webLaunchRequest?: WebLaunchRequest;
  webLaunchRequestError?: string;
}
